import { Image, Card, Row, Col, Form, Select, TimePicker } from "antd";
import HeadingBack from "../../../../component/HeadingBack";
import { FilePdfOutlined } from "@ant-design/icons";
import React, { useEffect, useState } from "react";
import { Input } from "antd";
import ProfileImg from "../../../../assets/images/icons/profilepic.jpg";
import { DashboardServices } from "../../../../redux/Services";
import { useMutation } from "react-query";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import moment from "moment";
import { v4 as uuidv4 } from "uuid";
import { UserId } from "../../../../utils";
import { usePermission } from "../../../../hooks/usePermission";
import { appConfig } from "../../../../config";
import { AntLoadingButton } from "../../../../component/LoadingButton";
const { Search } = Input;
const { Option } = Select;

const columns = [
  {
    title: "S.No.",
    dataIndex: "sno",
    key: "sno",
    className: "table_first_col"
    // render: (value, item, index) => (page - 1) * 10 + index + 1
  },
  {
    title: "Provider Name",
    dataIndex: "name"
  },
  {
    title: "Prescribed by",
    dataIndex: "Prescribed"
  },
  {
    title: "Date",
    dataIndex: "date"
  },
  {
    title: "Attachment",
    dataIndex: "age",
    className: "pdf_icon",
    render: (text) => <a>{text}</a>
  }
  // {
  //   title: 'Address',
  //   dataIndex: 'address',
  // },
];

const data = [
  {
    key: "1",
    sno: "1",
    name: "Lal PathLabs",
    Prescribed: "Lal PathLabs",
    date: "18 Jun 2023 2:54pm",
    age: <FilePdfOutlined />
  },
  {
    key: "2",
    sno: "2",
    name: "SRL Diagnostics",
    Prescribed: "SRL",
    date: "18 Jun 2023 2:54pm",
    age: <FilePdfOutlined />
  }
];
const ReportDetail = (onChange) => {
  // Asking consent starts a new HIU request
  const permission = usePermission("HIU Dashboard", "Add");
  const [form] = Form.useForm();
  const { search } = useLocation();
  const navigate = useNavigate();
  const healthId = new URLSearchParams(search).get("healthId");
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [offset, setOffset] = useState(0);
  const [searchData, setSearchData] = useState({});
  const dispatch = useDispatch();
  const { mutate: fetchgetCardsLogsSearch } = useMutation((data) =>
    dispatch(DashboardServices.fetchgetCardsLogsSearch(data))
  );
  const { mutateAsync: doConsentRequestInit } = useMutation((data) =>
    dispatch(DashboardServices.hiuConsentRequestInit(data))
  );
  // function onChange(checkedValues) {
  //     console.log('checked = ', checkedValues);
  //   }
  useEffect(() => {
    if (healthId) {
      onSearchCall(healthId);
    }
  }, [healthId]);

  const onSearchCall = (healthId) => {
    if (healthId?.trim()?.length > 0) {
      fetchgetCardsLogsSearch(
        { healthId, UserId },
        {
          onSuccess: (res) => {
            let data = res.data?.result;
            console.log(data,"data in search");
            
            if (data?.length > 0) {
              setSearchData(data[0]);
              let raw_data = JSON.parse(data[0]?.raw_data?data[0]?.raw_data:data[1]?.raw_data || "{}");
              // console.log(raw_data?.kycPhoto);
              form.setFieldsValue({
                fName: `${raw_data?.firstName || ""} ${
                  raw_data?.middleName || ""
                } ${raw_data?.lastName || ""}`,
                gender: raw_data?.gender,
                hid: raw_data?.healthIdNumber || raw_data?.ABHANumber,
                dob: `${
                  raw_data?.dayOfBirth +
                    -raw_data?.monthOfBirth +
                    -raw_data?.yearOfBirth || ""
                }`,
                phr: raw_data?.health_id || raw_data.preferredAbhaAddress
              });
            } else {
              setSearchData({});
              form.setFieldsValue({
                fName: "",
                gender: "",
                hid: "",
                health_id: ""
              });
            }
          }
        }
      );
    }
  };
  const [values, setValues] = useState({
    hiTypes: [],
    fromDate: "",
    toDate: "",
    purpose: "",
    expiryTime: null,
    expiryDate: ""
  });
  // console.log(values)
  var isButtonDisabled = false;

  if (
    values.hiTypes < 1 ||
    values.fromDate < 1 ||
    values.toDate < 1 ||
    values.purpose < 1 ||
    values.expiryDate < 1 ||
    values.expiryTime < 1
  ) {
    isButtonDisabled = true;
  } else if (Object.keys(searchData)?.length < 1) {
    isButtonDisabled = false;
  } else {
    isButtonDisabled = false;
  }

  const onSearch = (healthId) => {
    navigate(`/hip/report-detail?healthId=${healthId}`, { replace: true });
    onSearchCall(healthId);
  };
  const handleChange = (name, value) => {
    setValues({ ...values, [name]: value });
  };

  //   console.log(, "===+");

  let raw_data = JSON.parse(searchData?.raw_data || "{}");
  console.log(raw_data, "raw_data");
  const askContent = async () => {
    let combinedExpiryDateTime;
    if (moment.isMoment(values.expiryTime)) {
      combinedExpiryDateTime = moment(values.expiryDate)
        .hour(values.expiryTime.hour())
        .minute(values.expiryTime.minute())
        .second(values.expiryTime.second());
    } else {
      // Handle the case where expiryTime is not a moment object (e.g., set to a default time)
      combinedExpiryDateTime = moment(values.expiryDate);
    }
    let payload = {
      requestId: uuidv4(),
      timestamp: new Date().toISOString(),
      consent: {
        purpose: {
          text: `${values?.purpose}`,
          code: "CAREMGT"
        },
        patient: {
          id: `${raw_data?.preferredAbhaAddress}`
        },
        hiu: {
          id: appConfig.facilityId
          //   name: "Pathkind Labs NRL-HIP"
        },
        requester: {
          name: appConfig.drName,
          identifier: {
            type: "REGNO",
            value: appConfig.drRegNum,
            system: "https://www.pathkindlabs.com"
          }
        },
        hiTypes: values?.hiTypes,
        permission: {
          accessMode: "VIEW",
          dateRange: {
            from: new Date(values.fromDate).toISOString(),
            to: new Date(values.toDate).toISOString()
          },
          //   expiry_date_time: `${values?.expiryDate}T00:00:00.00Z`,
          // dataEraseAt: new Date(values.expiryDate).toISOString(),
          dataEraseAt: combinedExpiryDateTime.toISOString(),
          frequency: {
            unit: "DAY",
            value: 0,
            repeats: 0
          }
        }
      },
      patientInfo: {
        id: `${searchData.patient_id}`,
        patient_name: `${raw_data?.firstName || ""} ${
          raw_data?.middleName || ""
        } ${raw_data?.lastName || ""}`,
        // "patient_address": `${allData?.firstName || ""} ${allData?.middleName || ""} ${allData?.lastName || ""}`,
        abha_address: `${searchData?.health_id || ""}`,
        abha_number: `${searchData?.heathid_no || ""}`
      },
      requester: {
        name: appConfig.drName,
        identifier: {
          type: "REGNO",
          value: appConfig.drRegNum,
          system: "https://www.pathkindlabs.com"
        }
      }
    };
    // console.log(payload, "ppllood");
    const res = await doConsentRequestInit(payload);
    if (res?.status === 200) {
      navigate(`/hiu-consent-artifact-requested?healthId=${healthId}`);
    }
  };
  // const allData = JSON.parse(searchData?.raw_data || "{}");

  return (
    <div>
      <Row>
        <Col lg={16} md={16} sm={24} xs={24}>
          <HeadingBack title={"Patient Detail"} subHeading="" />
        </Col>
      </Row>
      <Card title="" bordered={false} className="report-d-card" style={{}}>
        <Row gutter={[24, 24]} align="middle">
          <Col lg={20} md={20} sm={24} xs={24}>
            <Search
              placeholder="ABHA Address"
              allowClear
              enterButton="Search"
              size="large"
              className="report-detail-search"
              // onChange={(e, time) => handleHiChange("healthId", healthId || null)}
              onSearch={onSearch}
              defaultValue={healthId}
            />
          </Col>
        </Row>
        <Row gutter={[24, 24]} align="middle" className="mt_25">
          <Col lg={5} md={5} sm={24} xs={24}>
            <strong>
              {" "}
              <p className="mb-2 ask-cons-d">
                Purpose<span className="c-red">*</span>
              </p>
            </strong>
            {/* <Form.Item
                            label=""
                            name="purpose"
                            className='mb-0'
                            onChange={(e) => handleChange("purpose", e.target.value)}
                            rules={[
                                { required: true, message: 'Purpose is required' },

                            ]}
                        >
                            <Input type="text" autoComplete="off" className='form-control' placeholder='Purpose' />
                        </Form.Item> */}
            <Select
              className="text-capitalize w-100"
              placeholder="Purpose"
              autoComplete="off"
              onChange={(value) => handleChange("purpose", value)}
            >
              {/* <label for className='text-capitalize' value="">Select Information Type</label> */}
              <Option
                className="text-capitalize"
                label="test"
                value={"Care Management"}
              >
                Care Management
              </Option>
              <Option className="text-capitalize" value={"Break the Glass"}>
                Break the Glass
              </Option>
              <Option className="text-capitalize" value={"Public Health"}>
                Public Health
              </Option>
              <Option className="text-capitalize" value={"Healthcare Payment"}>
                Healthcare Payment
              </Option>
              <Option
                className="text-capitalize"
                value={"Disease Specific Healthcare Research"}
              >
                Disease Specific Healthcare Research
              </Option>
              <Option className="text-capitalize" value={"Self Requested"}>
                Self Requested
              </Option>
            </Select>
          </Col>
          <Col md={4} sm={4} xs={24}>
            <strong>
              {" "}
              <p className="mb-2 ask-cons-d">
                From Date<span className="c-red">*</span>
              </p>
            </strong>
            <Input
              type="date"
              id="fromdate"
              autoComplete="off"
              className="form-control"
              onChange={(e) => handleChange("fromDate", e.target.value)}
              max={moment().format("YYYY-MM-DD")}
              placeholder="From Date"
              value={values?.fromDate}
            />
          </Col>

          <Col md={4} sm={4} xs={24}>
            <strong>
              <p className="mb-2 ask-cons-d">
                To Date<span className="c-red">*</span>
              </p>
            </strong>
            <Input
              type="date"
              id="todate"
              autoComplete="todate"
              className="form-control"
              onChange={(e) => {
                const selectedDate = e.target.value; // e.g., "2025-09-21"
                const nowUtc = moment.utc(); // Current time in UTC
                const selectedDateMoment = moment.utc(selectedDate); // Parse selected date as UTC

                let toDate;

                if (selectedDateMoment.isSame(nowUtc, "day")) {
                  // Selected date is today → use current UTC time
                  toDate = nowUtc.toISOString();
                } else {
                  // Selected date is before today → use 23:59:59 UTC of that date
                  toDate = selectedDateMoment.endOf("day").toISOString();
                }
                handleChange("toDate", toDate);
              }}
              min={values?.fromDate}
              max={moment().format("YYYY-MM-DD")}
              placeholder="To Date"
              value={
                values?.toDate ? moment(values.toDate).format("YYYY-MM-DD") : ""
              }
            />
          </Col>
          <Col md={8} sm={8} xs={24}>
            <Row>
              <Col md={12} sm={12} xs={24}>
                <strong>
                  {" "}
                  <p className="mb-2 ask-cons-d">
                    Expiry Date<span className="c-red">*</span>
                  </p>
                </strong>
                <Input
                  type="date"
                  id="fromdate"
                  autoComplete="off"
                  className="form-control"
                  onChange={(e) => handleChange("expiryDate", e.target.value)}
                  min={moment().format("YYYY-MM-DD")}
                  placeholder="From Date"
                  value={values?.expiryDate}
                />
              </Col>
              <Col md={12} sm={12} xs={24}>
                <strong>
                  {" "}
                  <p className="mb-2 ask-cons-d time-l">
                    Expiry Time<span className="c-red">*</span>
                  </p>
                </strong>
                <TimePicker
                  use12Hours
                  format="h:mm:ss A"
                  // onChange={(e, time) =>
                  //   handleChange("expiryTime", time || null)
                  // }
                  // onChange={(e) => handleChange("expiryTime", e)}
                  onChange={(timeMoment) =>
                    handleChange("expiryTime", timeMoment)
                  }
                  value={values.expiryTime || null}
                  /*  value={values?.expiryTime|| null} */ className="TimePicker"
                />
              </Col>
            </Row>
          </Col>

          <Col md={20} sm={20} xs={24}>
            <strong>
              <p className="mb-2 ask-cons-d">
                Information Type<span className="c-red">*</span>
              </p>
            </strong>
            <Select
              mode="multiple"
              className="text-capitalize w-100"
              placeholder="Information Type"
              autoComplete="off"
              // onChange={(value) => handleChange("hiTypes", value)}
              value={values.hiTypes}
              onChange={(value) => {
                if (value.includes("all")) {
                  handleChange("hiTypes", [
                    "DiagnosticReport",
                    "Prescription",
                    "ImmunizationRecord",
                    "DischargeSummary",
                    "OPConsultation",
                    "Invoice",
                    "HealthDocumentRecord",
                    "WellnessRecord"
                  ]);
                } else {
                  handleChange("hiTypes", value);
                }
              }}
            >
              {/* <label for className='text-capitalize' value="">Select Information Type</label> */}
              <Option className="text-capitalize" value="all">
                Select All
              </Option>
              <Option
                className="text-capitalize"
                label="test"
                value={"DiagnosticReport"}
              >
                Diagnostic Report
              </Option>
              <Option className="text-capitalize" value={"Prescription"}>
                Prescription
              </Option>
              <Option className="text-capitalize" value={"ImmunizationRecord"}>
                Immunization Record
              </Option>
              <Option className="text-capitalize" value={"DischargeSummary"}>
                Discharge Summary
              </Option>
              <Option className="text-capitalize" value={"OPConsultation"}>
                OP Consultation
              </Option>
              <Option className="text-capitalize" value={"OPConsultation"}>
                Invoice Record
              </Option>
              <Option
                className="text-capitalize"
                value={"HealthDocumentRecord"}
              >
                Health Document Record
              </Option>
              <Option className="text-capitalize" value={"WellnessRecord"}>
                Wellness Record
              </Option>
            </Select>
          </Col>
          <Col lg={2} md={2} sm={24} xs={24} className="text-right">
            <AntLoadingButton
              type="primary"
              className="ask-r-btn"
              onClick={askContent}
              disabled={isButtonDisabled}
            >
              Ask Consent
            </AntLoadingButton>
          </Col>
        </Row>

        <div className="ask-report-box-label">
          <h3> Patient Detail </h3>
        </div>

        <Row gutter={[24, 0]}>
          <Col lg={4} md={4} sm={24} xs={24}>
            <div className="pt_image">
              <Image
                preview={false}
                src={
                  raw_data?.profilePhoto
                    ? `data:image/png;base64,${raw_data?.profilePhoto}`
                    : ProfileImg
                }
              />
            </div>
          </Col>
          <Col lg={18} md={18} sm={24} xs={24}>
            <Form
              form={form}
              name="basic"
              layout={"vertical"}
              autoComplete="off"
            >
              <Row gutter={[24, 0]}>
                <Col lg={12} md={12} sm={24} xs={24}>
                  <Form.Item
                    label="Name"
                    name="fName"
                    rules={[{ required: false, message: "" }]}
                  >
                    <Input
                      type="text"
                      autoComplete="off"
                      className="form-control"
                      placeholder=""
                      readOnly
                    />
                  </Form.Item>
                </Col>
                <Col lg={12} md={12} sm={24} xs={24}>
                  <Form.Item
                    label="ABHA Address"
                    name="phr"
                    rules={[{ required: false, message: "" }]}
                  >
                    <Input
                      type="text"
                      autoComplete="off"
                      className="form-control"
                      placeholder=""
                      readOnly
                    />
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={[24, 0]}>
                <Col lg={12} md={12} sm={24} xs={24}>
                  <Form.Item
                    label="ABHA Number"
                    name="hid"
                    rules={[{ required: false, message: "" }]}
                  >
                    <Input
                      type="text"
                      autoComplete="off"
                      className="form-control"
                      placeholder=""
                      readOnly
                    />
                  </Form.Item>
                </Col>
                <Col lg={12} md={12} sm={12} xs={24}>
                  <Form.Item
                    label="Gender"
                    name="gender"
                    rules={[{ required: false, message: "" }]}
                  >
                    <Input
                      type="text"
                      autoComplete="off"
                      className="form-control"
                      placeholder=""
                      readOnly
                    />
                  </Form.Item>
                </Col>
                <Col lg={12} md={12} sm={12} xs={24}>
                  <Form.Item
                    label="Date Of Birth"
                    name="dob"
                    rules={[{ required: false, message: "" }]}
                  >
                    <Input
                      type="text"
                      autoComplete="off"
                      className="form-control"
                      placeholder=""
                      readOnly
                    />
                  </Form.Item>
                </Col>
              </Row>
            </Form>
          </Col>
        </Row>
      </Card>
    </div>
  );
};

export default ReportDetail;
